import { CCol, CRow, CSpinner, CFormSelect } from '@coreui/react'
import React, { useEffect } from 'react'
import { RefreshSVG, SearchBtnVG } from '../../../../../components/IconSvg'
import { enToPersianChar } from '../../../../../components/helper'
import { useLocation, useNavigate } from 'react-router-dom'
import { SearchFreeProposeNumberRequestAction, getFreeProposedNumbersRequestAction, getProposedNumbersRequestAction, searchProposedNumbersRequestAction } from '../../../../../service/actions/purchaseActions'
import { useDispatch } from 'react-redux'

import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { useSelector } from 'react-redux'
import { Line } from '../../../../../service/interfaces/purchase'
import { IRootState } from '../../../../../service/store'

type Props = {
  selectedNumber: Line | undefined, states: any, setStates: Function, prefixNumberList: any[], isSPLBuyPage: boolean, externalPurchase: boolean
}

const HeadTools = (props: Props) => {
  const getLinesPending: boolean = useSelector((state: IRootState) => state.purchaseReducer.selectPackagePending)
  const getSearchLinesPending: boolean = useSelector((state: IRootState) => state.purchaseReducer.searchFreeProposedNumbersPending)
  const productNumbersCount = useSelector((state: any) => state.purchaseReducer.packageNumbersCount)
  const responseLines = useSelector((state: IRootState) => state.purchaseReducer.resultLines) as [Line]
  const [CStates, setCStates] = CustomValuesHook({ contextWidth: 0 })

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (responseLines === null) {
      handleGetFreeNumber()
    }
    setCStates({ contextWidth: window.innerWidth })
    window.onresize = handleContextDetection
    if (!location.state?.productType && location.pathname.indexOf("/purchaseLine/selectionNumber") === -1) {
      navigate("/extend/packages")
    }
  }, [])
  useEffect(() => {
    handleSearchNumber(undefined);
  }, [props.states.prefixedLineType])

  const handleContextDetection = () => {
    setCStates({ contextWidth: window.innerWidth })

  }

  const handleSearchNumber = (e: any | undefined) => {
    if (e) {
      e.preventDefault()

    }

    if (!props.states?.searchQuery) {
      handleGetFreeNumber()

    } else {
      props.setStates({ isSearch: true })
      if (props.isSPLBuyPage) {
        dispatch(searchProposedNumbersRequestAction({
          ivrEnabled: false,
          secretaryEnabled: false,
          voicemailEnabled: false,
          faxEnabled: false,
          outgoingCallEnabled: false,
          cityCode: "+98",
          number: !props.states.searchQuery ? "" : props.states.searchQuery,
          prefixedLineType: parseInt(props.states.prefixedLineType)

        }))
      } else {
        dispatch(SearchFreeProposeNumberRequestAction({
          productId: location?.state?.productId,
          number: !props.states.searchQuery ? "" : props.states.searchQuery,
          prefixedLineType: parseInt(props.states.prefixedLineType)

        }))
      }


    }
  }

  const handleGetFreeNumber = () => {
    props.setStates({ isSearch: false })
    if (props.isSPLBuyPage) {
      dispatch(getProposedNumbersRequestAction({
        ivrEnabled: false,
        secretaryEnabled: false,
        voicemailEnabled: false,
        faxEnabled: false,
        outgoingCallEnabled: false,
        cityCode: "+98",
        number: '',
        prefixedLineType: parseInt(props.states.prefixedLineType)
      }))
    } else {
      dispatch(getFreeProposedNumbersRequestAction({
        productId: location?.state?.productId,
        number: !props.states.searchQuery ? "" : props.states.searchQuery,
        prefixedLineType: parseInt(props.states.prefixedLineType)
      }))
    }



  }

  return (
    <div className='header-tools row mt-5' >

      {CStates.contextWidth > 1024 && <CCol lg={2} md={0} sm={0} xs={0}></CCol>}
      <CCol lg={8} md={12} sm={12} xs={12}>
        <CRow className='align-items-center'>
          <CCol sm={12} lg={4} xs={12} >
            <form onSubmit={handleSearchNumber}>
              <div className='form-group' >
                <div className='input-group' >
                  <input type='text'
                    className='form-control'
                    value={props.states.searchQuery}
                    onChange={(e) => props.setStates({ searchQuery: e.target.value })}
                    placeholder='جستجوی شماره...' />
                  <span className='input-group-btn' >
                    <button
                      type='button'
                      className='btn btn-default'
                      onClick={handleSearchNumber}
                    >
                      {!getSearchLinesPending ? <SearchBtnVG fill='#aaa' /> : <CSpinner color="default" />}
                    </button>
                  </span>
                </div>
              </div>
            </form>

          </CCol>
          <CCol lg={8} sm={12} md={12} xs={12} >
            <CRow className='refresh-btn-container'>
              {location.state?.productType?.toString() !== "4" && <CCol lg={10} md={10} xs={10} className='selected-line-description'>
                <CFormSelect value={props.states.prefixedLineType} onChange={(e) => props.setStates({ prefixedLineType: e.target.value })}>
                  {!props.states.prefixedLineType ? <option>انتخاب پیش شماره</option> : <option>انتخاب همه</option>}
                  {location.pathname.indexOf("/purchaseLine/selectionNumber") === -1 ? PrefixedLineTypes(location.state?.productType?.toString()).map((type: any, idx: number) => <option value={type.type} key={idx} >{type.text}</option>) :
                    PrefixedLineTypes("purchaseLine").map((type: any, idx: number) => <option value={type.type} key={idx} >{type.text}</option>)}
                </CFormSelect>
              </CCol>}
              <CCol lg={2} md={2} xs={2} style={{ textAlign: 'end' }}>
                <button
                  onClick={() => { handleGetFreeNumber(); props.setStates({ searchQuery: '' }) }}
                  type='button'
                  className='btn btn-default' >
                  {getLinesPending ? <CSpinner color="default" /> : <RefreshSVG fill='#aaa' />}
                </button>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>

    </div>
  )
}

export default HeadTools


const PrefixedLineTypes = (productType: string) => {

  switch (true) {
    case (productType === "1"):
      return [{ type: 2, text: "*******۲(۰۲۱)" }, { type: 3, text: "*******۷(۰۲۱)" }]

    case (productType === "2"):

      return [{ type: 1, text: "*******۹(۰۲۱)" }, { type: 2, text: "*******۲(۰۲۱)" }, { type: 3, text: "*******۷(۰۲۱)" }]

    case (productType === "purchaseLine"):
      return [{ type: 1, text: "*******۹(۰۲۱)" }, { type: 2, text: "*******۲(۰۲۱)" }, { type: 3, text: "*******۷(۰۲۱)" }]
    default:
      return []

  }
}

